import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonScopeClass;
function JsonScope() {
  if (JsonScopeClass === VOID) {
    class $ {
      constructor() {
        this.e4a_1 = 1;
        this.f4a_1 = 2;
        this.g4a_1 = 3;
        this.h4a_1 = 4;
        this.i4a_1 = 5;
        this.j4a_1 = 6;
        this.k4a_1 = 7;
        this.l4a_1 = 8;
      }
      m4a(stackSize, stack, pathNames, pathIndices) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().p2();
        var inductionVariable = 0;
        if (inductionVariable < stackSize)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            switch (stack[i]) {
              case 1:
              case 2:
                // Inline function 'kotlin.collections.plusAssign' call

                var element = pathIndices[i];
                result.i2(element);
                break;
              case 3:
              case 4:
              case 5:
                var tmp1_safe_receiver = pathNames[i];
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.collections.plusAssign' call
                  result.i2(tmp1_safe_receiver);
                }

                break;
              case 7:
              case 6:
              case 8:
                break;
            }
          }
           while (inductionVariable < stackSize);
        return result;
      }
    }
    initMetadataForObject($, 'JsonScope');
    JsonScopeClass = $;
  }
  return JsonScopeClass;
}
var JsonScope_instance;
function JsonScope_getInstance() {
  return JsonScope_instance;
}
//region block: init
JsonScope_instance = new (JsonScope())();
//endregion
//region block: exports
export {
  JsonScope_instance as JsonScope_instance35augazrw8idg,
};
//endregion

//# sourceMappingURL=JsonScope.mjs.map
